import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Col, Form, FormGroup, Input, Row } from "reactstrap";
import { MessageResultState } from "../../../../types/general-types";
import { inject, observer } from "mobx-react";
import LoginStore from "./store";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import Button from "../../../../components/Button";
import { BiLogIn } from "react-icons/bi";
import { setSessionKey, setUser } from "../../../../utils/SsoSession";
import { Controller, useForm } from "react-hook-form";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import LanguageSelection from "../../../../components/Layout/partials/Header/parts/languageSelection";
import AccountActionStore from "./store";
import {
  ChangePasswordRequestDto,
  SendChangePasswordLinkRequestDto,
  SendChangePasswordLinkResponseDto,
} from "./types";
import ContactInfoConfirmPage from "./contact-info-confirm-modal";
import cx from "classnames";
import ECaptcha from "../../../../components/e-captcha";

interface IPage {
  AccountActionStore?: AccountActionStore;
}
const LoginPage: FC<IPage> = inject("AccountActionStore")(
  observer((props: IPage) => {
    const { AccountActionStore: store } = props;
    const { t, i18n } = useTranslation();
    const [animationShow, setAnimationShow] = useState<boolean>(false);
    const [muted, setMuted] = useState<boolean>(false);
    const recaptchaRef = useRef<ReCAPTCHA>(null); // reCAPTCHA referansı
    const [contactInfoConfirmData, setContactInfoConfirmData] =
      useState<SendChangePasswordLinkResponseDto>();
    const [contactInfoConfirmModal, setContactInfoConfirmModal] =
      useState(false);
    const toggleContactInfoConfirmModal = () =>
      setContactInfoConfirmModal(!contactInfoConfirmModal);

    const {
      control,
      handleSubmit,
      errors,
      formState,
      watch,
      setValue,
      getValues,
      register,
    } = useForm<SendChangePasswordLinkRequestDto>({
      defaultValues: {
        eCaptchaToken: "",
        eCaptchaCode: "",
        username: "",
      },
    });

    register("eCaptchaToken");

    useEffect(() => {
      let videoElement: HTMLVideoElement | null =
        document.querySelector("#video_1");
      if (videoElement) {
        setMuted(false);
        setMuted(true);
      }
    }, []);

    const animation = useMemo(() => {
      return (
        <>
          <div className="h-100 bg-plum-plate bg-animation">
            <video
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                objectFit: "cover",
                top: 0,
                left: 0,
                zIndex: animationShow ? -1 : -2,
              }}
              src="https://strsecuritasdigicloud.blob.core.windows.net/upload-1324d8f0-8e85-49cf-8aa2-46b1f147/ui_videos/login_2.mp4"
              controls={false}
              id={"video_2"}
              muted={muted}
            />

            <video
              style={{
                width: "100vw",
                height: "100vh",
                position: "fixed",
                objectFit: "cover",
                top: 0,
                left: 0,
                zIndex: animationShow ? -2 : -1,
              }}
              src="https://strsecuritasdigicloud.blob.core.windows.net/upload-1324d8f0-8e85-49cf-8aa2-46b1f147/ui_videos/login_1.mp4"
              controls={false}
              autoPlay={true}
              muted={muted}
              loop={true}
              id={"video_1"}
            />
            <div className="d-flex h-100 justify-content-center align-items-center mt-5 content">
              <Col
                md="4"
                className="mx-auto app-login-box p-3 mt-5"
                style={{ backgroundColor: "white", borderRadius: 10 }}
              >
                <div className=" mx-auto mb-3" />

                <div className="modal-dialog w-100 mx-auto">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="h5 modal-title text-center mb-4">
                        <h4 className="mt-2">
                          <span>
                            {t("Please fill in the information below.")}
                          </span>
                        </h4>
                      </div>
                      <form>
                        <Row>
                          <Col md={11}>
                            <FormGroup>
                              <Controller
                                name={"username"}
                                control={control}
                                rules={{
                                  required: t("*Please fill out this field."),
                                  pattern: {
                                    value:
                                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                    message: t(
                                      "Please enter a valid email address."
                                    ),
                                  },
                                  maxLength: {
                                    value: 50,
                                    message: t(
                                      "The given value should be smaller than {{ value }}.",
                                      { value: 50 }
                                    ),
                                  },
                                  minLength: {
                                    value: 15,
                                    message: t(
                                      "The given value should be greater than {{ value }}.",
                                      { value: 15 }
                                    ),
                                  },
                                }}
                                render={(field) => (
                                  <input
                                    {...field}
                                    id={"username"}
                                    className={cx("form-control ", {
                                      "is-invalid": errors["username"],
                                    })}
                                    placeholder={t("Email")}
                                    onChange={(e) => {
                                      field.onChange(e.target.value);
                                    }}
                                  />
                                )}
                              />
                              {errors.username && (
                                <div className="invalid-feedback">
                                  {errors.username.message}
                                </div>
                              )}
                            </FormGroup>
                          </Col>

                          <Col md={12}>
                            <FormGroup>
                              <Controller
                                name={"eCaptchaCode"}
                                control={control}
                                rules={{
                                  required: t("*Please fill out this field."),
                                }}
                                render={(field) => (
                                  <ECaptcha
                                    length={5}
                                    onChange={(data) => {
                                      field.onChange(data.code);
                                      setValue("eCaptchaToken", data.token);
                                    }}
                                  />
                                )}
                              />
                              {errors.eCaptchaCode && (
                                <div
                                  className="invalid-feedback"
                                  style={{ display: "block" }}
                                >
                                  {errors.eCaptchaCode.message}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md={12}>
                            <FormGroup></FormGroup>
                          </Col>
                          <div className="divider" />

                          <Col md={12}>
                            <FormGroup className="recaptcha-container">
                              <div className="modal-footer clearfix">
                                <div className="float-right">
                                  <Button
                                    text={t("Send")}
                                    className="btn btn-primary"
                                    onClick={handleSubmit(async () => {
                                      if (store)
                                        await store
                                          .ChangePasswordCheckUsername(
                                            getValues()
                                          )
                                          .then((response) => {
                                            if (
                                              response.state ===
                                              MessageResultState.SUCCESS
                                            ) {
                                              setContactInfoConfirmData(
                                                response.result
                                              );
                                              toggleContactInfoConfirmModal();
                                            }
                                          });
                                    })}
                                    type="submit"
                                    itemRef="buttonRef"
                                  ></Button>
                                </div>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="text-center opacity-8 mt-3">
                  Copyright &copy; Securitas
                </div>
              </Col>
            </div>
          </div>
          {contactInfoConfirmModal && contactInfoConfirmData && (
            <ContactInfoConfirmPage
              AccountActionStore={store}
              contactInfoConfirmData={contactInfoConfirmData}
              sendChangePasswordLinkRequestData={getValues()}
              isShow={contactInfoConfirmModal}
              toggleModal={toggleContactInfoConfirmModal}
            />
          )}
          {/* <ToastContainer /> */}
        </>
      );
    }, [
      animationShow,
      contactInfoConfirmData,
      contactInfoConfirmModal,
      control,
      errors,
      getValues,
      handleSubmit,
      muted,
      setValue,
      store,
      t,
      toggleContactInfoConfirmModal,
    ]);

    return <div>{animation}</div>;
  })
);

export default LoginPage;
